import { GetStaticProps } from 'next';
import { IShopDineAndRelaxPageData } from '../../../features/shop-dine-and-relax/domain/models/IShopDineAndRelaxPageData';
import ShopDineAndRelaxPage from '../../../features/shop-dine-and-relax/ui/overview/ShopDineAndRelaxPage';
import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { getPois } from '../../../features/shop-dine-and-relax/domain/use-cases/getPois';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IShopDineAndRelaxPageData> =
	createGetStaticPropsWithPage(PassengersPageId.ShopDineAndRelax, {
		pois: getPois,
	});

export default ShopDineAndRelaxPage;
